import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9af0ddec&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./assets/style/app.css?vue&type=style&index=0&lang=css&"
import style1 from "./assets/style/transicoes.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af0ddec",
  null
  
)

export default component.exports